export default "__VITE_ASSET__CaxT5eAk__"